import { ELEMENT_TYPES } from '@@editor/helpers/Element';
import { PLUGIN_NAMES } from '@@editor/typings/UnityPlugins';

export const TYPE = PLUGIN_NAMES.EMBEDDED_SNIPPET;
export const NODE_TYPE = ELEMENT_TYPES.EMBEDDED_SNIPPET;
